/** @import ../../common/types.js */

import { enableMapSet } from 'immer'
import './../../common/types'
import {
  createMonthlyMonitoringFilterConfig,
  createStatutoryDisclosureFilter,
  createTrainingResignationFilterConfig,
  monthlyMonitoringFilterPattern,
  statutoryDisclosurePattern,
  trainingResignationFilterPattern
} from './FilterFactory'

enableMapSet()

/** QuickSightに渡すパラメータ */
export const filterParameter = Object.fromEntries([
  ['6.1.2', monthlyMonitoringFilterPattern],
  ['6.2.2', monthlyMonitoringFilterPattern],
  ['6.2.3', monthlyMonitoringFilterPattern],
  ['5.2.3', trainingResignationFilterPattern],
  ['5.2.4', trainingResignationFilterPattern],
  ['5.2.5', trainingResignationFilterPattern],
  ['5.2.6', trainingResignationFilterPattern],
  ['5.2.7', trainingResignationFilterPattern],
  ['5.2.8', trainingResignationFilterPattern],
  ['10.1.5', statutoryDisclosurePattern],
  ['10.2.1', statutoryDisclosurePattern],
  ['10.4.1', statutoryDisclosurePattern]
])

/** 取得兼初期データ処理 */
export default {
  '6.1.2': createMonthlyMonitoringFilterConfig,
  '6.2.2': createMonthlyMonitoringFilterConfig,
  '6.2.3': createMonthlyMonitoringFilterConfig,
  '5.2.3': (args) => createTrainingResignationFilterConfig(args, 1),
  '5.2.4': (args) => createTrainingResignationFilterConfig(args, 1),
  '5.2.5': (args) => createTrainingResignationFilterConfig(args, 1),
  '5.2.6': (args) => createTrainingResignationFilterConfig(args, 2),
  '5.2.7': (args) => createTrainingResignationFilterConfig(args, 2),
  '5.2.8': (args) => createTrainingResignationFilterConfig(args, 3),
  '10.1.5': createStatutoryDisclosureFilter, // 女性管理職比率
  '10.2.1': createStatutoryDisclosureFilter, // 賃金差異
  '10.4.1': createStatutoryDisclosureFilter // 育休休暇取得
}
